const smallButtonClass = 'btn-small';
const lgBreakpoint = 1024;

export const initializeResponsiveClasses = () => {
    const responsiveConfigs = [{
        components: document.querySelectorAll('.js-btn-responsive'),
        breakpoint: lgBreakpoint,
        onBelowBreakpoint: classList => classList.add(smallButtonClass),
        onAboveBreakpoint: classList => classList.remove(smallButtonClass),
    }];

    applyResponsiveConfig(responsiveConfigs);
    window.addEventListener("resize", () => applyResponsiveConfig(responsiveConfigs));

};

const applyResponsiveConfig = (responsiveConfigs) => {
    responsiveConfigs.forEach(config => {
        if (!config.components.length) return;

        if (window.innerWidth < config.breakpoint) {
            config.components.forEach(component => config.onBelowBreakpoint(component.classList));
        } else {
            config.components.forEach(component => config.onAboveBreakpoint(component.classList));
        }
    });
}
